import { Expose } from "class-transformer";
import { UserInformalOfferBase } from "domain/model/base";

export default class UserInformalOffer extends UserInformalOfferBase {
  @Expose({ name: "user_name" })
  userName?: string;
}
